export const BLUE: string = "3C82CA";
export const GREEN: string = "3DAC1F";
export const RED: string = "C92134";